const Container = ({ children }) => <>
  <div className='w-full h-full relative border twy-bg-base-accent twy-border-base-accent rounded py-[30px] px-[50px]'>
    {children}
  </div>
</>

export default Container
